var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useMemo, useRef, useState } from 'react';
import useCommonProps from './useCommonProps';
var FILE_EXTENSION_REGEXP = /(?:\.([^.]+))?$/;
/**
 * Возвращает реф для контейнера, под который нужно подобрать ресайз
 * и выбранный из массива файл
 */
export var getImageToWidth = function (files, targetWidth) {
    var filesSafe = files ? __spreadArray([], files, true) : [];
    var pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio;
    var resized = filesSafe.reduce(function (result, item) {
        var width = item.width;
        if (width >= targetWidth * pixelRatio) {
            return {
                resized: item,
            };
        }
        return result;
    }, {
        resized: null,
    }).resized;
    return resized || filesSafe.find(function (_a) {
        var size = _a.size;
        return size === 'original';
    });
};
export var useResizedImageEnhanced = function (files, fixedSize) {
    var filesSafe = useMemo(function () { return files ? __spreadArray([], files, true) : []; }, [files]);
    var containerRef = useRef(null);
    var _a = useState(), container = _a[0], setContainer = _a[1];
    var containerWidth = (fixedSize === null || fixedSize === void 0 ? void 0 : fixedSize.width) || (container === null || container === void 0 ? void 0 : container.offsetWidth);
    var containerHeight = (fixedSize === null || fixedSize === void 0 ? void 0 : fixedSize.heigth) || (container === null || container === void 0 ? void 0 : container.offsetHeight);
    var pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio;
    var targetWidth = (containerWidth || 0) * pixelRatio;
    var targetHeight = (containerHeight || 0) * pixelRatio;
    var showOriginals = useCommonProps().showOriginals;
    var image = useMemo(function () {
        if (!containerWidth) {
            return null;
        }
        var resized = filesSafe.reduce(function (result, item) {
            var width = item.width, height = item.height;
            var area = width * height;
            var smallestArea = result.smallestArea;
            if (width >= targetWidth && height >= targetHeight && (!smallestArea || area < smallestArea)) {
                return {
                    resized: item,
                    smallestArea: area,
                };
            }
            return result;
        }, {
            smallestArea: 0,
            resized: null,
        }).resized;
        var largest = filesSafe.reduce(function (result, item) {
            var width = item.width, height = item.height;
            var area = width * height;
            var largestArea = result.largestArea;
            if (!largestArea || area > largestArea) {
                return {
                    largest: item,
                    largestArea: area,
                };
            }
            return result;
        }, {
            largestArea: 0,
            largest: null,
        }).largest;
        var _a = FILE_EXTENSION_REGEXP.exec(largest === null || largest === void 0 ? void 0 : largest.url) || [], ext = _a[1];
        var isGif = ext === 'gif';
        return showOriginals || isGif ? largest : (resized || largest);
    }, [targetWidth, filesSafe, showOriginals]);
    useEffect(function () {
        if (containerRef.current) {
            setContainer(containerRef.current);
        }
    }, []);
    return [image, containerRef];
};
//# sourceMappingURL=useResizedImageEnhanced.js.mapvar __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useMemo, useRef, useState } from 'react';
import useCommonProps from './useCommonProps';
var FILE_EXTENSION_REGEXP = /(?:\.([^.]+))?$/;
/**
 * Возвращает реф для контейнера, под который нужно подобрать ресайз
 * и выбранный из массива файл
 */
export var getImageToWidth = function (files, targetWidth) {
    var filesSafe = files ? __spreadArray([], files, true) : [];
    var pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio;
    var resized = filesSafe.reduce(function (result, item) {
        var width = item.width;
        if (width >= targetWidth * pixelRatio) {
            return {
                resized: item,
            };
        }
        return result;
    }, {
        resized: null,
    }).resized;
    return resized || filesSafe.find(function (_a) {
        var size = _a.size;
        return size === 'original';
    });
};
export var useResizedImageEnhanced = function (files, fixedSize) {
    var filesSafe = useMemo(function () { return files ? __spreadArray([], files, true) : []; }, [files]);
    var containerRef = useRef(null);
    var _a = useState(), container = _a[0], setContainer = _a[1];
    var containerWidth = (fixedSize === null || fixedSize === void 0 ? void 0 : fixedSize.width) || (container === null || container === void 0 ? void 0 : container.offsetWidth);
    var containerHeight = (fixedSize === null || fixedSize === void 0 ? void 0 : fixedSize.heigth) || (container === null || container === void 0 ? void 0 : container.offsetHeight);
    var pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio;
    var targetWidth = (containerWidth || 0) * pixelRatio;
    var targetHeight = (containerHeight || 0) * pixelRatio;
    var showOriginals = useCommonProps().showOriginals;
    var image = useMemo(function () {
        if (!containerWidth) {
            return null;
        }
        var resized = filesSafe.reduce(function (result, item) {
            var width = item.width, height = item.height;
            var area = width * height;
            var smallestArea = result.smallestArea;
            if (width >= targetWidth && height >= targetHeight && (!smallestArea || area < smallestArea)) {
                return {
                    resized: item,
                    smallestArea: area,
                };
            }
            return result;
        }, {
            smallestArea: 0,
            resized: null,
        }).resized;
        var largest = filesSafe.reduce(function (result, item) {
            var width = item.width, height = item.height;
            var area = width * height;
            var largestArea = result.largestArea;
            if (!largestArea || area > largestArea) {
                return {
                    largest: item,
                    largestArea: area,
                };
            }
            return result;
        }, {
            largestArea: 0,
            largest: null,
        }).largest;
        var _a = FILE_EXTENSION_REGEXP.exec(largest === null || largest === void 0 ? void 0 : largest.url) || [], ext = _a[1];
        var isGif = ext === 'gif';
        return showOriginals || isGif ? largest : (resized || largest);
    }, [targetWidth, filesSafe, showOriginals]);
    useEffect(function () {
        if (containerRef.current) {
            setContainer(containerRef.current);
        }
    }, []);
    return [image, containerRef];
};
//# sourceMappingURL=useResizedImageEnhanced.js.map